import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import error_45clear_45global from "/app/middleware/error-clear.global.js";
import locale_45global from "/app/middleware/locale.global.js";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  error_45clear_45global,
  locale_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}